/** @jsx jsx */
import { useMemo } from 'react';
import { jsx, Text } from 'theme-ui';
import { observer } from 'mobx-react';
import { useOTF } from '../../woff-provider/use-otf';
import { useFontLoader } from '../../woff-provider/use-font-loader';

export const TextF5 = observer(
  ({ variant, font, features = [], children, className = '', ...rest } = { features: [] }) => {
    let otf = useOTF(font);
    useFontLoader(font);

    const fontFeatureSettings = useMemo(() => {
      return features
        .reduce((res, f) => {
          res.push(`"${f.key}" 1`);
          return res;
        }, [])
        .join(', ');
    }, [features]);

    return (
      <Text
        {...rest}
        variant={variant}
        className={`${className} ${otf.cssFontFamily}`}
        sx={{
          opacity: 0,
          fontFamily: `"${otf.cssFontFamily}"`,
          fontFeatureSettings: fontFeatureSettings,
        }}
      >
        {children}
      </Text>
    );
  }
);

export default TextF5;
